import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewMode } from '@src/models';
import { fixRouteParam } from '@src/utils';

import { BaseResizableComponent } from '../../base';

import { LpProductRequestService } from './services/lp-product-request.service';

@Component({
  selector: 'app-lp-product-request',
  templateUrl: './lp-product-request.component.html',
  styleUrls: ['./lp-product-request.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpProductRequestComponent extends BaseResizableComponent {
  private readonly lpProductRequestService = inject(LpProductRequestService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  private readonly productRequests$ = this.lpProductRequestService.productRequests$;

  selectedProductRequestId?: string;
  productRequestMode: ViewMode = 'view';

  loading = false;

  override ngOnInit(): void {
    super.ngOnInit();

    this.route.paramMap.pipe(takeUntil(this.destroyed$$)).subscribe(params => {
      this.selectedProductRequestId = fixRouteParam(params.get('productRequestId'));

      if (this.selectedProductRequestId) {
        this.productRequestMode = 'view';
      }

      this.cdr.markForCheck();
    });
  }

  onCancelEditing() {
    if (this.productRequestMode === 'create') {
      this.selectedProductRequestId = undefined;

      if (!this.productRequests$.value?.length) {
        this.router.navigate(['loyalty']);
      }
    }

    this.productRequestMode = 'view';
  }

  onSaveProductRequest() {
    this.productRequestMode = 'view';
    this.router.navigate(['loyalty', 'product-request']);
  }

  onDeleteProductRequest() {
    this.selectedProductRequestId = undefined;
    this.productRequestMode = 'view';
    this.router.navigate(['loyalty', 'product-request']);
  }

  onSelectProductRequest(id: string) {
    this.productRequestMode = 'view';
    this.router.navigate(['loyalty', 'product-request', id]);
  }

  onClickCreateButton() {
    this.selectedProductRequestId = undefined;
    this.productRequestMode = 'create';
    this.cdr.detectChanges();
  }

  onClickEditButton() {
    this.productRequestMode = 'edit';
  }
}
